import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { FlangeFacingTypeModel } from '../../../models';
import { Subject } from 'rxjs';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { CalculationType } from '../../../enums/calculation-type.enum';

@Component({
    selector: 'app-flange-facing-type',
    templateUrl: './flange-facing-type.component.html',
    styleUrls: ['./flange-facing-type.component.scss'],
    standalone: false,
})
export class FlangeFacingTypeComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;

    @Input()
    set flangeTypeId(value: string) {
        this._flangeTypeId = value;
        if (!this.jointCalcService.isPipeCode) this.getFlangeFacingTypes();
    }
    get flangeTypeId(): string {
        return this._flangeTypeId;
    }

    @Input()
    set pressureClassId(value: string) {
        this._pressureClassId = value;
        if (!this.jointCalcService.isPipeCode) this.getFlangeFacingTypes();
    }
    get pressureClassId(): string {
        return this._pressureClassId;
    }

    @Input()
    set pipeSizeId(value: string) {
        this._pipeSizeId = value;
        if (!this.jointCalcService.isPipeCode) this.getFlangeFacingTypes();
    }
    get pipeSizeId(): string {
        return this._pipeSizeId;
    }
    destroy$ = new Subject();

    loading: boolean = false;
    tooltip_position = 'above';
    flangeFacingTypeList: FlangeFacingTypeModel[];

    private _flangeTypeId: string;
    private _pressureClassId: string;
    private _pipeSizeId: string;

    constructor(
        private iceapi: IceapiService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private jointCalcService: JointCalcService,
        private router: Router,
        private dataService: DataService
    ) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();
        this.form
            .get('flangeFacingType')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                this.setFlangeFacingValues(value);
                if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
                    this.jointCalcService.selectedflangeFacingType.next(value);
                }
            });
        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithFlangefacing();
        }
    }

    getFlangeFacingTypes(): void {
        this.form.markAllAsTouched();
        if (this.flangeTypeId != undefined) {
            this.loading = true;
            this.iceapi
                .getFlangeFacingTypes(this.flangeTypeId, this.pressureClassId, this.pipeSizeId)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                        this.cd.markForCheck();
                    })
                )
                .pipe(takeUntil(this.destroy$))
                .subscribe((flangeFacingTypes) => {
                    if (flangeFacingTypes.success === true) {
                        this.flangeFacingTypeList = flangeFacingTypes.response;
                        if (this.dataService.calculationData?.input?.recordId?.flangeFacingTypeId)
                            this.form.get('flangeFacingType').setValue(this.dataService?.calculationData?.input?.recordId?.flangeFacingTypeId);
                        else if (this.flangeFacingTypeList.length === 1)
                            this.form.get('flangeFacingType').setValue(this.flangeFacingTypeList[0].flangeFacingTypeId);
                        this.cd.markForCheck();
                        if (this.form.get('flangeFacingType').value !== '') this.setFlangeFacingValues(this.form.get('flangeFacingType').value);
                    } else {
                        this.user_utility.errorModelPopup(flangeFacingTypes.message);
                    }
                });
        }
    }

    setFlangeFacingValues(flangeFacingTypeId: string) {
        if (flangeFacingTypeId != null) {
            this.form.get('isRTJ').setValue(this.flangeFacingTypeList.find((x) => x.flangeFacingTypeId == flangeFacingTypeId)?.isRtj);
            this.form.get('flangeFacingDiagramId').setValue(this.flangeFacingTypeList.find((x) => x.flangeFacingTypeId == flangeFacingTypeId)?.diagramId);
        }
    }

    async pipespecwithFlangefacing() {
        this.jointCalcService.selectedflangeType.pipe(takeUntil(this.destroy$)).subscribe(async (ft) => {
            if (ft && this.jointCalcService.pipeSpecpayload.lookupParams.calculationType == CalculationType.StandardFlange) {
                this.loading = true;
                let InputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
                InputGroup.recordId.flangeTypeId = ft;

                InputGroup.recordId.flangeMaterialId =
                    InputGroup.recordId.gasketId =
                    InputGroup.others.boltType =
                    InputGroup.recordId.boltMaterialId =
                    InputGroup.others.tighteningSpecification =
                        null;

                let pipeSpecFlangeFacingType = await this.iceapi
                    .getFlangeFacingTypes(ft, this.pressureClassId, null)
                    .pipe(
                        finalize(() => {
                            this.loading = false;
                            this.cd.detectChanges();
                        })
                    )
                    .toPromise();
                if (pipeSpecFlangeFacingType.success) {
                    this.flangeFacingTypeList = pipeSpecFlangeFacingType.response;
                    this.flangeFacingTypeList = await this.jointCalcService.managePayloadForRecourdId('flangeFacingTypeId', this.flangeFacingTypeList);
                    if (
                        this.dataService.calculationData?.input?.recordId?.flangeFacingTypeId &&
                        this.flangeFacingTypeList.some((x) => x.flangeFacingTypeId == this.dataService.calculationData.input.recordId.flangeFacingTypeId)
                    ) {
                        this.form.get('flangeFacingType').setValue(this.dataService?.calculationData?.input?.recordId?.flangeFacingTypeId);
                    } else if (this.flangeFacingTypeList.length === 1) {
                        this.form.get('flangeFacingType').setValue(this.flangeFacingTypeList[0].flangeFacingTypeId);
                    }
                    this.setFlangeFacingValues(this.form.get('flangeFacingType').value);
                    this.cd.markForCheck();
                } else if (pipeSpecFlangeFacingType.isCustom) {
                    this.user_utility.errorModelPopup(pipeSpecFlangeFacingType.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
